import React from 'react';
import { IoMdClose } from "react-icons/io";
import {Row,Col} from 'react-bootstrap'
import { Modal, Typography} from "components";

const AgentRequestViewModal = ({showModal, onClose, data}) => {
  const displayData = [
    {
      id: 1,
      fieldName: "OEM Name",
      fieldValue: data?.oem
    },
    {
      id: 2,
      fieldName: "Serial Number",
      fieldValue: data?.serialNumber
    },
    {
      id:3,
      fieldName: "Device IMEI",
      fieldValue: data?.imei
    },
    {
      id:4,
      fieldName: "Terminal ID",
      fieldValue:data?.terminalId
    }
  ]
  return (
      <React.Fragment>
        <Modal
        showModal={showModal}
        onClose={onClose}
        size="lg"
        >
        
          <Row  className="my-4">
            <Col md={12}>
              <div className="d-flex justify-content-end">
                <IoMdClose className="cursor-pointer" onClick={onClose} />
              </div>
            </Col>
            <Col md={12}>
              <Typography variant="subtitle3" className="text-center mb-3" state="primary">
                Terminal Details
              </Typography> 
              <Typography variant="body2" className="mb-1 text-center">
                Details below are for terminal requested to be swapped
              </Typography>
            </Col>
            <Col md={12} className="mt-3">
                <Row>
                  {displayData?.map(data=>(
                    <Col md={6} key={data.id} className="my-3">
                      <span>{data.fieldName}</span>
                      <div className="bg-style">
                        {data.fieldValue}
                      </div>
                    </Col> 
                  ))}
                </Row>
            </Col>
          </Row>
        </Modal>
      </React.Fragment>
  )
};

export default AgentRequestViewModal;
